import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";
import { createOpeningInterview } from "./api";

function buildPayload(values) {
    if (!values || typeof values !== "object") return {};

    const { applicant, ...rest } = values;

    const payload = {
        ...Object.fromEntries(
            Object.entries(rest).filter(
                ([_, v]) => v !== "" && v !== undefined && v !== null
            )
        ),
        status: values.status,
    };

    if (applicant !== undefined) {
        payload.applicant = applicant?.id;
    }

    return payload;
}

export function useCreateOpeningInterview() {
    return useMutation({
        mutationFn: async ({ values }) => {
            const payload = buildPayload(values);

            try {
                const response = await createOpeningInterview({ item: payload });
                return response;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: () => {
            invalidateAllQueries();
            toast.success("Interview Scheduled Successfully");
        },
        onError: (error) => {
            toast.error(error.message);
            console.log(error.message);
        },
    });
}
